import {IAppRoute} from "../../application/config/IAppRoute";
import {routeLanePlanningPage} from "./routeLanePlanningPage";

export const routesLanePlanning: IAppRoute<any>[] = [
  routeLanePlanningPage,
];
